import React from "react";
import { Title, Image, List, Text, Button } from "@mantine/core";
import { GiHealthNormal } from "react-icons/gi";

const Home = ({ setIsDrawerOpen }) => {
  return (
    <div className="Home" style={{ padding: "100px 8vw 15px 8vw" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%" }}>
          <Title order={1} style={{ fontSize: 120 }}>
            Stay Healthy
          </Title>
          <Title order={2} style={{ fontSize: 50 }}>
            Leave the rest to us
          </Title>
          <List
            icon={<GiHealthNormal color="green" />}
            style={{ marginTop: 10 }}
          >
            <List.Item>
              <Text weight={700} color="dimmed">
                All your health records under one place
              </Text>
            </List.Item>
            <List.Item>
              <Text weight={700} color="dimmed">
                Less waiting time
              </Text>
            </List.Item>
            <List.Item>
              <Text weight={700} color="dimmed">
                Virtual appointment at your convenience
              </Text>
            </List.Item>
            <List.Item>
              <Text weight={700} color="dimmed">
                and more...
              </Text>
            </List.Item>
          </List>
          <Button
            color="indigo"
            size="lg"
            uppercase
            style={{ marginTop: 25 }}
            onClick={() => setIsDrawerOpen((prev) => !prev)}
          >
            Sign Up Today
          </Button>
        </div>
        <div style={{ width: 1300, margin: "auto" }}>
          <Image
            radius="md"
            src="./assets/illus4.png"
            alt="stay healthy"
            withPlaceholder
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
